import axios from 'axios';
import { configRefs } from '@utils/constants';

async function updateLocationRequest(productId, user, descriptor, objectId) {
  const endpoint = await configRefs.apis.userdata.get();
  if (objectId) {
    await axios.put(`${endpoint}/api/ProgressionsV2/${encodeURIComponent(objectId)}`, {
      userID: user.id,
      userInstitutionID: user.institution?.id,
      productID: productId,
      dynamicContent: descriptor
    });
    return {
      descriptor,
      objectId
    };
  } else {
    const res = await axios.post(`${endpoint}/api/ProgressionsV2`, {
      userID: user.id,
      userInstitutionID: user.institution?.id,
      productID: productId,
      dynamicContent: descriptor
    });
    return {
      descriptor,
      objectId: res.data.objectID
    };
  }
}

export { updateLocationRequest };
//# sourceMappingURL=update-location.request.js.map
